// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2RRnh","topBottomGutter":"Layout_topBottomGutter__1xs86"};